export default __webpack_public_path__ + "static/media/logo.d2f9fd63.svg";